import { render } from "./Venues.vue?vue&type=template&id=23b68a58&scoped=true"
import script from "./Venues.vue?vue&type=script&lang=js"
export * from "./Venues.vue?vue&type=script&lang=js"

import "./Venues.vue?vue&type=style&index=0&id=23b68a58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b68a58"]])

export default __exports__